import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';

interface SummaryRowSkeletonProps {
  labelKey: string;
  'aria-description'?: string;
  loadingColor?: string;
}

export const SummaryRowSkeleton: React.FC<SummaryRowSkeletonProps> = ({
  labelKey,
  'aria-description': ariaDescription,
  loadingColor,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <Flex justifyContent="space-between" alignItems="center" aria-description={ariaDescription}>
      <Text fontWeight="normal" lineHeight="6" color="var(--text-muted, #8F8F8F)">
        {t(labelKey)}
      </Text>
      <Skeleton height="1rem" width="3rem" startColor={loadingColor} endColor="var(--border, #E0E0E0)" />
    </Flex>
  );
};
